import {
    DELETE_ORDER,
    DELETE_ORDER_SUCCESS,
    DELETE_ORDER_FAILURE,
    SHOW_DELETE_ORDER,
} from '../actions/index';

const initialState = {
    loading: false,
    statusCode: '',
    statusMessage: '',
    deleteMyCaseRef: '',
    isDeletePopup: false,
    isOrderDetailsModal: false,
    isOtherUser: false,
};

const DeleteOrderReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_ORDER:
            return { ...state, statusCode: '', loading: true };
        case DELETE_ORDER_SUCCESS:
            return {
                ...state,
                statusCode: action.payload.statusCode,
                loading: false,
                deleteMyCaseRef: '',
                isOrderDetailsModal: false,
                isOtherUser: false,
            };
        case DELETE_ORDER_FAILURE:
            return {
                ...state,
                statusCode: action.payload.statusCode,
                loading: false,
                ...action.payload,
                deleteMyCaseRef: '',
                isOrderDetailsModal: false,
                isOtherUser: false,
            };
        case SHOW_DELETE_ORDER:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default DeleteOrderReducer;
